export const regexOnlyNumbersUpTo8 = /^[0-9]{0,8}$/
export const regexOnlyNumbersUpTo15WithSpaces = /^[0-9]{0,15}$/
 
export const validateDni = (dni?: string): boolean => {
	if (!dni) return true
	return /^[0-9]{7,8}$/.test(dni);
};
 
export const validateEmail = (email?: string): boolean => {
	if (!email) return true
	return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};
 
export const validatePhone = (phone?: string): boolean => {
	if (!phone) return true
	return /^\+?[\d\s-]{0,20}$/.test(phone);
}